export const SET_HRMS19X_INDEX_DISP = 'SET_HRMS19X_INDEX_DISP'
export const GET_HRMS19X_INDEX_DISP = 'GET_HRMS19X_INDEX_DISP'
export const GET_HRMS19X_MAX_ROWSPAN = 'GET_HRMS19X_MAX_ROWSPAN'
export const SET_HRMS19X_COLUMNS = 'SET_HRMS19X_COLUMNS'
export const GET_HRMS19X_COLUMNS = 'GET_HRMS19X_COLUMNS'
export const SET_HRMS19X_LABELS = 'SET_HRMS19X_LABELS'
export const GET_HRMS19X_LABELS = 'GET_HRMS19X_LABELS'
export const RECEIVED_HRMS19X_COLUMNS_LABELS = 'RECEIVED_HRMS19X_COLUMNS_LABELS'
export const SET_HRMS19X_INDEX = 'SET_HRMS19X_INDEX'
export const GET_HRMS19X_INDEX = 'GET_HRMS19X_INDEX'
export const RECEIVED_HRMS19X_INDEX = 'RECEIVED_HRMS19X_INDEX'



// WEBPACK FOOTER //
// ./src/store/modules/hrms19x/mutation-types.js